<template>
  <div class="grid-view">
    <div class="main-content">
      <!-- 铁路操作 300 铁路头程 10014-->
      <search-item
        :ref="searchItemConfigModule"
        :config-module="searchItemConfigModule"
        :is-collapse-list="!isFba"
        :grid-options="gridOptions"
        :grid-config-module="isFba ? '10014' : '170001'"
        :is-append-query="true"
        :reset="true"
        lob="RE"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :record-expand-status="true"
        :input-enter-query="true"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <template slot="operations">
          <el-button
            :disabled="!selectedRow || hqDisabledViewDetail || (!isHQ && !validSingleSelect) || hierarchyDisabledViewDetail"
            no="look"
            type="success"
            @click="toLook()"
          >{{ $t('common.btn.look') }}</el-button>
          <el-button
            :disabled="!(selectedRow && Number(selectedRow.jobState) === 0 && !JobUtils.isBlockJob(selectedRow)) || !validSingleSelect || !hierarchyValidSingleSelect"
            no="edit"
            type="success"
            @click="toEdit"
          >{{ $t('common.btn.edit') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_REBooking_addREBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
            no="new"
            :disabled="hqDisabledOperate"
            type="primary"
            style="margin-right: 5px"
            @click="toAdd()"
          >{{ $t('common.btn.new') }}</el-button>
          <el-dropdown
            v-show="$checkPermission(['button_REBooking_addREBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
            no="exportOrderHandle"
            :disabled="hqDisabledOperate"
            split-button
            type="primary"
            style="margin:0 5px"
            @click="exportOrderHandle()"
            @command="p=>{exportOrderCommand=p;exportOrderHandle()}"
          >
            <span v-show="exportOrderCommand !== $t('SeaExport.import')">{{ exportOrderCommand }}</span>
            <el-upload
              v-show="exportOrderCommand === $t('SeaExport.import')"
              :action="actionOrderUrl"
              :headers="headers"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeOrderUpload"
              :on-success="uploadOrderSuccess"
              :on-error="handleError"
              :data="{branchId:$store.getters.currentOfficeId, lob:'RE'}"
              style="display: inline-block; margin-left: 5px"
            >
              <span style="color: white">{{ $t('SeaExport.import') }}</span>
            </el-upload>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.Add')">
                {{ $t('SeaExport.Add') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="!isFba" :command="$t('SeaExport.import')">
                {{ $t('SeaExport.import') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="!isFba" :command="$t('CargoMsg.Cargo_DownImportTemplate')">
                {{ $t('CargoMsg.Cargo_DownImportTemplate') }}
              </el-dropdown-item>
              <!--FBA相关导入-->
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAReBooking_addRailFbaOrder'])" :command="$t('FbaJob.batchImportOrder')">
                <el-upload
                  ref="uploadBatchOrder"
                  :action="URL.seaExport.batchImportFbaJob"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeFbaOrderUpload"
                  :on-success="uploadOrderSuccess"
                  :on-error="handleError"
                  :data="{branchId:$store.getters.currentOfficeId, deptId:$store.getters.currentDeptId, lob: 'FBA_RE'}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">
                    <span>
                      <img src="@/assets/fba-import.png">
                    </span>
                    {{ $t('FbaJob.batchImportOrder') }}
                  </el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAReBooking_addRailFbaOrder'])" :command="$t('FbaJob.downloadBatchImportTemplate')">
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadBatchImportTemplate') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAReBooking_addRailFbaOrder'])" :command="$t('FbaJob.importSingleOrder')">
                <el-upload
                  ref="uploadSingleOrder"
                  :action="URL.booking.railwayExport.fbaSingleImport"
                  :headers="headers"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeFbaOrderUpload"
                  :on-success="uploadSingleOrderSuccess"
                  :on-error="handleError"
                  :data="{officeId:$store.getters.currentOfficeId, deptId:$store.getters.currentDeptId}"
                  style="display: inline-block"
                >
                  <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">
                    <span>
                      <img src="@/assets/fba-import.png">
                    </span>
                    {{ $t('FbaJob.importSingleOrder') }}
                  </el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item v-if="isFba && $checkPermission(['button_FBAReBooking_addRailFbaOrder'])" :command="$t('FbaJob.downloadSingleImportTemplate')">
                <span>
                  <img src="@/assets/fba-download.png">
                </span>
                {{ $t('FbaJob.downloadSingleImportTemplate') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-show="$checkPermission(['button_REBooking_addLCL'])"
            no="AddHbl"
            :disabled="hqDisabledOperate"
            type="primary"
            @click="toAdd({masterFlag: true})"
          >{{ $t('SeaExport.AddHbl') }}</el-button>
          <el-button
            no="SplitHbl"
            type="primary"
            :disabled="!enableBtnSplit || !validMultipleSelect"
            @click="toSplit"
          >{{ $t('SeaExport.SplitHbl') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_REBooking_addREBooking'])"
            no="Clone"
            :disabled="!selectedRow || !validSingleSelect || !hierarchyValidSingleSelect"
            type="primary"
            @click="toCopy"
          >{{ $t('SeaExport.Clone') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_deleteREJob'])"
            no="Delete"
            :disabled="!validMultipleSelect"
            type="danger"
            @click="toDelete"
          >{{ $t('SeaExport.Delete') }}</el-button>
          <el-dropdown
            v-if="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)"
            no="exportHandle"
            split-button
            type="primary"
            :disabled="!validMultipleSelect"
            style="margin: 0 5px;"
            @click="exportHandle"
            @command="p=>{exportCommand=p;exportHandle()}"
          >
            {{ exportCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('SeaExport.ExportToExcel')"
              >{{ $t('SeaExport.ExportToExcel') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ExportWithSOPToExcel')"
              >{{ $t('SeaExport.ExportWithSOPToExcel') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button no="EditSopStatus" :disabled="!validMultipleSelect" type="primary" @click="editState">{{ $t('SeaExport.EditSopStatus') }}</el-button>
          <el-button
            v-show="$checkPermission(['button_JobBooking_BatchShutOut'])"
            no="BatchShutOut"
            :disabled="!batchSelectFlag || !validMultipleSelect"
            type="primary"
            @click="toShutOut"
          >{{ $t('SeaExport.BatchShutOut') }}</el-button>
          <!-- <el-button
            v-show="$checkPermission(['button_print_batchPrint'])"
            :disabled="!batchSelectFlag || !validMultipleSelect"
            no="BatchPrint"
            type="primary"
            @click="onBatchPrint"
          >{{ $t('SeaExport.BatchPrint') }}</el-button> -->
          <el-dropdown
            v-show="$checkPermission(['button_print_batchPrint'])"
            no="BatchPrint"
            :disabled="!batchSelectFlag || !validMultipleSelect"
            split-button
            type="primary"
            style="margin: 0 5px;"
            @click="onBatchPrint($t('SeaExport.BatchPrint'))"
            @command="onBatchPrint"
          >
            {{ $t('SeaExport.BatchPrint') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-show="$checkPermission(['button_REBooking_batchVessel'])"
            :disabled="!batchSelectFlag || !validMultipleSelect"
            no="batchVessel"
            type="primary"
            @click="toBatchTransship"
          >{{ $t('RailwayExport.batchVessel') }}</el-button>
          <el-button no="xxx" :disabled="!validMultipleSelect" type="primary" @click="toStatistics">{{ $t('SeaExport.Statistics') }}</el-button>
          <el-dropdown
            no="batchHandle"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary" :disabled="!batchSelectFlag || !validMultipleSelect">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchPerCommit'])" :command="1">{{ $t('SeaExport.BatchPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchCommit'])" :command="2">{{ $t('SeaExport.BatchCommit') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchManagerSubmission'])" :command="3">{{ $t('SeaExport.BatchManagerSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnToOperater'])" :command="4">{{ $t('SeaExport.BatchReturnPreSubmission') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_Retract'])" :command="5">{{ $t('SeaExport.BatchReturnSubmit') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockReceivable'])" :command="6">{{ $t('SeaExport.BatchLockingReceivableExpenses') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_Charge_BatchLockPayable'])" :command="7">{{ $t('SeaExport.BatchLockingPayableFees') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_FBARailwayExport_fbaBatchUpdateRailDestinationMsg']) && isFba" :command="8">{{ $t('RailwayExport.BulkModifyDestinationPortInformation') }}</el-dropdown-item>
              <el-dropdown-item
                v-if="$checkPermission(['button_REBooking_BatchUpdateCustomJobType'])"
                :disabled="!$checkPermission(['button_REBooking_BatchUpdateCustomJobType'])"
                :command="9"
              >{{ $t('SeaExport.BatchUpdateCustomJobType') }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_REBooking_BatchUpdateJobInfo'])" :command="17">{{ $t('SeaExport.BatchModifyBusiness') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_jobSopTab_BatchReplaceTemplate'])" :command="18">{{ $t('SeaExport.ReplaceSOPTemplatesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="useOrderCenterMode&&!isRegionalCommission" :command="19">{{ $t('queryJob.BatchInitiateCollaboration') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchFillGpExplain'])" :command="20">{{ $t('SeaExport.BatchFillGpExplain') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchLockJob'])" :command="21">{{ $t('CargoMsg.Cargo_BatchServiceLocking') }}</el-dropdown-item>
              <el-dropdown-item :disabled="!$checkPermission(['button_JobBooking_BatchUnlockJob'])" :command="22">{{ $t('CargoMsg.Cargo_UnlockServicesInBatches') }}</el-dropdown-item>
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_ReturnReview'])" :command="24">{{ $t('CargoMsg.Cargo_BatchReturnPreApproval') }}</el-dropdown-item>
              <!-- 出口-指令操作按钮 -->
              <template v-for="(item, index) in reInstructioinBtns">
                <el-dropdown-item
                  :key="'instruction' + index"
                  :disabled="!item.allowOperate"
                  :command="'instruction,RE,' + item.tenantInstructionUuid"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-dropdown-item>
              </template>
              <!-- 进口-指令操作按钮 -->
              <template v-for="(item, index) in riInstructioinBtns">
                <el-dropdown-item
                  :key="'instruction' + index"
                  :disabled="!item.allowOperate"
                  :command="'instruction,RI,' + item.tenantInstructionUuid"
                >
                  {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            v-show="$checkPermission(['tab_Charge_chargeView'])"
            no="chargeHandle"
            :disabled="!validMultipleSelect"
            split-button
            type="primary"
            style="font-size: 12px"
            @click="chargeHandle"
            @command="p=>{chargeCommand=p;chargeHandle()}"
          >
            {{ chargeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('SeaExport.AddCharges')"
              >{{ $t('SeaExport.AddCharges') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.EditCharges')"
              >{{ $t('SeaExport.EditCharges') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.DeleteCharges')"
              >{{ $t('SeaExport.DeleteCharges') }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ChargeImport')"
              >{{ $t('SeaExport.ChargeImport') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <!-- 铁路操作 170001 铁路头程 10014-->
        <cargo-ag-grid-wrapper
          v-if="!isFba"
          config-module="170001"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          style="width: 100%;"
          @gridReady="params=>{gridApi=params.api}"
          @columnRowGroupChanged="() => { this.$refs[searchItemConfigModule].clickCollapseList() }"
        />
        <cargo-ag-grid-wrapper
          v-if="isFba"
          config-module="10014"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :column-defs="fbaColumnDefs"
          :row-data="rowData"
          :check-main-record="false"
          :deselect-main-record="false"
          :show-selected-color="false"
          :show-row-groups="dataListDragGroup"
          :darg-group-show-column-def="dargGroupShowColumnDef"
          style="width: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <!-- 铁路操作 170001 铁路头程 10014-->
        <cargo-pagination
          v-show="!appendQuery"
          :config-module="isFba ? '10014' : '170001'"
          :total="total"
          :page-count="pageCount"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="toQuery()"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 状态修改弹窗 -->
    <state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :tracking-list="stateDialog.trackingList"
      @callback="toQuery()"
    />
    <!-- 批量退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      no="shutOut"
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}？</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button
          no="HasChargeToShutOut"
          type="primary"
          @click="hasChargeShutoutHandler"
        >{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button
          no="NoChargeToShutOut"
          :style="{ display: shutOutDialog.shutOutButtonShow2 }"
          type="primary"
          @click="noHasChargeShutoutHandler"
        >{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button no="cancel" @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量转船弹窗 -->
    <el-dialog
      v-if="transshipDialog.visible"
      v-el-drag-dialog
      no="batchVessel"
      :visible.sync="transshipDialog.visible"
      :title="$t('RailwayExport.batchVessel')"
      width="360px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('RailwayExport.vessel')">
          <div style="display: flex">
            <el-input
              v-show="transshipDialog.isDBFlag"
              v-model="transshipDialog.txtVessel_1"
              :disabled="clearCheckBox.vessel"
              no="txtVessel_1"
              style="width:195px;"
            />
            <el-checkbox v-model="clearCheckBox.vessel" style="margin-left: 10px" @change="clearCheckBoxChange('vessel')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.voyageFlight')">
          <div style="display: flex">
            <el-select
              v-show="!transshipDialog.isDBFlag"
              v-model="transshipDialog.txtVoyage"
              :disabled="clearCheckBox.voyage"
              no="txtVoyage"
              style="width:195px;"
            >
              <el-option
                v-for="(item) in transshipDialog.voyages"
                :key="item.voyageId"
                :label="item.voyageNo"
                :value="item.voyageNo"
              />
            </el-select>
            <el-input
              v-show="transshipDialog.isDBFlag"
              v-model="transshipDialog.txtVoyage_1"
              :disabled="clearCheckBox.voyage"
              no="txtVoyage_1"
              style="width:195px;"
            />
            <el-checkbox v-model="clearCheckBox.voyage" style="margin-left: 10px" @change="clearCheckBoxChange('voyage')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.ETD')">
          <el-date-picker
            v-model="transshipDialog.dfETD"
            no="dfETD"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:173px;"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.portAgent')">
          <div style="display: flex">
            <cargo-advance-select
              no="txtPortAgent"
              filterable
              style="width:195px;"
              options-width="200px;"
              :method-params="{portAgent:true}"
              :select-type="TYPE_NAMES.basic_data_Company"
              :default-value="transshipDialog.txtPortAgent||''"
              :disabled="clearCheckBox.portAgent"
              @parentCallBack="p=>{transshipDialog.txtPortAgent=p.cmpIdx}"
            />
            <el-checkbox v-model="clearCheckBox.portAgent" style="margin-left: 10px" @change="clearCheckBoxChange('portAgent')">{{ $t('CargoMsg.Cargo_ClearData') }}</el-checkbox>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="confirm" type="primary" @click="transShipClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" @click="transshipDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      no="Statistics"
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      :width="$selectByLang('360px', '445px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Slaves')" class="auto-width">
          <el-input v-model="statisticsDialog.txtSlaves" no="txtSlaves" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Master')" class="auto-width">
          <el-input v-model="statisticsDialog.txtMaster" no="txtMaster" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')" class="auto-width">
          <el-input v-model="statisticsDialog.txtCount" no="txtCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')" class="auto-width">
          <el-input v-model="statisticsDialog.txtCustomerCount" no="txtCustomerCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="20＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt20" no="txt20" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt40" no="txt40" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40HQ＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt40hq" no="txt40hq" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="45＇" class="auto-width">
          <el-input v-model="statisticsDialog.txt45" no="txt45" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="TEU" class="auto-width">
          <el-input v-model="statisticsDialog.txtTeu" no="txtTeu" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Weight2')" class="auto-width">
          <el-input v-model="statisticsDialog.txtWeight" no="txtWeight" style="width:160px" :disabled="true" />
          <span>KGS</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Cubage')" class="auto-width">
          <el-input v-model="statisticsDialog.txtCubage" no="txtCubage" style="width:160px" :disabled="true" />
          <span>CBM</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ChargedWeight')" class="auto-width">
          <el-input v-model="statisticsDialog.txtChargeWeight" no="txtChargeWeight" style="width:160px" :disabled="true" />
          <span>M/T</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="auto-width">
          <el-input v-model="statisticsDialog.txtdesignationAgentNum" no="txtdesignationAgentNum" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" @change="handleStatistics(true)">{{ $t('SeaExport.ContainShutOutJob') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statisticsDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      lob="RE"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :charge-type="addChargeDetailDialog.type"
      :lob="isFba ? 'FBA_RE' : 'RE'"
      :location="location"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 编辑费用弹窗 -->
    <edit-charge-detail-dialog
      v-if="editChargeDetailDialog.visible"
      :visible.sync="editChargeDetailDialog.visible"
      :selected-jobs="editChargeDetailDialog.selectedJobs"
      :charge-type="editChargeDetailDialog.chargeType"
      :lob="isFba ? 'FBA_RE' : 'RE'"
    />
    <!-- 删除费用弹窗 -->
    <delete-charge-detail-dialog
      v-if="deleteChargeDetailDialog.visible"
      :visible.sync="deleteChargeDetailDialog.visible"
      :selected-jobs="deleteChargeDetailDialog.selectedJobs"
      :charge-type="deleteChargeDetailDialog.chargeType"
      :lob="isFba ? 'FBA_RE' : 'RE'"
    />
    <!-- 导入铁路业务类型选择 -->
    <el-dialog
      v-if="importJobLobDialog.visible"
      v-el-drag-dialog
      :visible.sync="importJobLobDialog.visible"
      :title="$t('CargoMsg.Cargo_BusinessType')"
      :width="$selectByLang('300px', '300px', '300px', '400px', '400px', '400px')"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="importJobLobDialog.visible=false"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <el-radio-group v-model="importJobLobDialog.lob">
          <el-radio label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
          <el-radio label="RI" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-upload
          :action="actionOrderUrl"
          :headers="headers"
          :show-file-list="false"
          accept=".xls, .xlsx"
          :before-upload="beforeOrderUpload"
          :on-success="uploadOrderSuccess"
          :data="{branchId: $store.getters.currentOfficeId, lob: importJobLobDialog.lob}"
          style="display: inline-block; margin-left: 5px"
        >
          <el-button type="primary">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        </el-upload>
        <el-button @click="() =>{this.importJobLobDialog.visible=false}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量修改目的港信息 -->
    <el-dialog
      v-if="podInfo.visible"
      v-el-drag-dialog
      :visible.sync="podInfo.visible"
      :title="$t('RailwayExport.BulkModifyDestinationPortInformation')"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="display: flex; flex: 1;">
        <el-form label-width="120px" label-position="left" style="padding-right: 20px">
          <el-row>
            <el-col :span="12">
              <el-form-item :title="$t('RailwayExport.NonWarehouseOverseasTransferWarehouse')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.estimatedDeliveryToWarehouseTime"
                  no="45"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :title="$t('RailwayExport.NonWarehouseOverseasTransferWarehouse')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.deliveryTime"
                  no="46"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.destPortDeliveryTime"
                  no="47"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
                <el-date-picker
                  v-model="podInfo.deliveryCompletionDate"
                  no="48"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('RailwayExport.EstimatedDeliveryTime')">
                <el-date-picker
                  v-model="podInfo.estDeliveryTime"
                  no="49"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('RailwayExport.ActualDeliveryTime')">
                <el-date-picker
                  v-model="podInfo.actDeliveryTime"
                  no="50"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.EstimatedReturnTime')">
                <el-date-picker
                  v-model="podInfo.estimatedReturnTime"
                  no="51"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('SeaExport.ActualReturnTime')">
                <el-date-picker
                  v-model="podInfo.destPortReturnTime"
                  no="52"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="confirmBatchModifyPodInfo()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="podInfo.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />
    <!-- 批量修改业务弹窗 -->
    <batch-modify-business-dialog
      :visible.sync="batchModifyBusinessDialog.visible"
      :job-keys="batchModifyBusinessDialog.jobKeys"
      :job-list="batchModifyBusinessDialog.jobList"
      :lob="batchModifyBusinessDialog.lob"
      @callback="batchModifyBusinessCallback"
    />
    <!-- 批量修改业务SOP模板弹窗 -->
    <change-sop-template-dialog
      :visible.sync="changeSopTemplateDialog.visible"
      :lob="changeSopTemplateDialog.lob"
      :job-list="changeSopTemplateDialog.jobList"
      @reload="reload"
    />
    <!-- 批量协作弹窗 -->
    <batch-cooperation-dialog :visible.sync="batchCooperationDialog.visible" :job-list="batchCooperationDialog.jobList" :order-center-branch="orderCenterBranch" />

    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :job="chargeSchemeBatchDialog.job"
      :need-check-range="chargeSchemeBatchDialog.needCheckRange"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :location="location"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />
    <!-- 下载导入模板弹窗 -->
    <download-import-template-dialog
      :visible.sync="downloadImportTemplateDialog.visible"
      :lob="downloadImportTemplateDialog.lob"
    />
    <!-- 业务申请审批流 实质是：job-apply-dialog-->
    <job-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :doc-id="workFlowApplyDialog.documentProcess.docId"
      :document-config-id="workFlowApplyDialog.documentProcess.documentConfigId"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        toQuery()
      }"
    />
    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="gpExplain.jobUuids"
    />
    <!-- 批量修改自定义业务类型弹窗 -->
    <el-dialog
      v-if="customJobTypeDialog.visible"
      v-el-drag-dialog
      :visible.sync="customJobTypeDialog.visible"
      :title="$t('SeaExport.BatchUpdateCustomJobType')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" label-position="left">
        <el-form-item :label="$t('SeaExport.CustomJobType')+':'">
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :method-params="{type: customJobTypeDialog.lobType,fba: isFba, active: true}"
            :default-value="customJobTypeDialog.customJobType"
            @parentCallBack="p=>{customJobTypeDialog.customJobType=p.value}"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="customJobTypeClickHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="customJobTypeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="RE"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="list"
      @confirm="toQuery"
    />

    <!-- 应收应付类型选择弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeTypeDialog.visible"
      :title="$t('CargoMsg.Cargo_AddCostType')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 30px 30px;">
        <el-radio-group v-model="chargeTypeDialog.type" size="small">
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_Receivable') }}</el-radio>
          <el-radio :label="2">{{ $t('CargoMsg.Cargo_Dues') }}</el-radio>
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_ARAP') }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onChargeTypeDialogConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeTypeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 同租户交叉委托窗口 -->
    <tenant-entrust-window ref="tenantEntrustWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>
import bookingTreeGridJS from './bookingTreeGrid.js'
import jobDetailIcon from '@/assets/job-detail.png'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import addChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog'
import editChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/editChargeDetailDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import URL from '@/api/urlTranslator'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import StateDialog from '@/components/Cargo/Job/StateDialog'
import { isBpmEnabled, workflowActionBatch } from '@/api/workflow'
import WorkflowConstants, { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import DeleteChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue'
import BatchModifyBusinessDialog from '@/views/cargo/v0/SeaExport/components/booking/batchModifyBusinessDialog.vue'
import { LOG_AE_AIR_BOOKING, LOG_RE_RAILWAY_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import ChangeSopTemplateDialog from '@/components/Cargo/Job/booking/tabs/changeSopTemplateDialog'
import BatchCooperationDialog from '@/components/Cargo/Job/BatchCooperationDialog'
import { operateBranchIsOptional } from '@/utils/basicDataCache'
import ChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import DownloadImportTemplateDialog from '@/views/cargo/v0/SystemMaintenance/components/orderTemplateConfig/downloadImportTemplateDialog'
import { cache } from '@/utils/cacheManager'
import JobWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import DateUtils from '@/utils/dateUtils'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import TenantEntrustWindow from '@/components/Cargo/Job/tenantEntrustWindow/index'

export default {
  name: 'ReBookingTreeGrid',
  components: { jobReturnReviewDialog, cargoAgGridWrapper, ChargeSchemeBatchDialog, ChangeSopTemplateDialog, BatchModifyBusinessDialog, DeleteChargeDetailDialog, searchItem, cargoTemplateSelectorDialog, CargoAdvanceSelect, BatchCheckingWindow, addChargeDetailDialog, editChargeDetailDialog, StateDialog, batchSubmitOrApproveDialog, BatchCooperationDialog, DownloadImportTemplateDialog, JobWorkFlowApplyDialog, AddGpExplainDialog, TenantEntrustWindow },
  mixins: [BookingTreeGridMixin],
  props: {
    context: { type: Object, required: true },
    isFba: { type: Boolean, required: false },
    isQuery: { type: Boolean, default: false }
  },
  data() {
    return {
      notRefresh: false,
      appendQuery: false, // 追加查询
      TYPE_NAMES,
      URL,
      allowPartialCheckPass: false, // CARGO-1677，批量提交业务时，部分业务不符合校验规则导致全部业务都无法提交
      ticketsMustBeVoted: false, // 当整拼类型为自拼箱时，判断开关是否开启拒绝提交
      checkApChargeVerify: false, // 业务预提交时是否验证应付费用已全部审核
      useCheckRule: false, // 是否启用验证规则
      isAdvancedQuery: false, // 是否为高级查询
      simpleFilter: {
        conditions: [],
        branchId: 0
      },
      complexFilter: {
        conditions: [],
        branchId: 0
      },
      customJobTypeDialog: {
        visible: false,
        jobKeys: [],
        jobList: [],
        customJobType: '',
        lobType: ''
      },
      selectTypeNames: TYPE_NAMES,
      pageNum: 1,
      pageSize: 50,
      total: 0,
      pageCount: 0,
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob && currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              // const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}</span>`
            }
          }
        },
        onRowDataChanged: event => {
          // 重置（多选）选中行
          this.selectedRows = []
          if (!this.isFba) {
            this.$refs[this.searchItemConfigModule].clickCollapseList()
          }
        },
        // 单选（勾选框或者其他列，都会触发）
        onCellFocused: (event) => {
          this.selectedRowIndex = event.rowIndex
        },
        // 多选（勾选框触发）
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        onCellDoubleClicked: event => {
          if (!event.data) {
            return
          }
          if (this.hierarchyViewList && !this.hierarchyViewDetail) {
            if (!this.matchOwnerBranch(event.data)) {
              return
            }
          }
          if (this.hqViewAllList) {
            const curOfficeId = this.$store.getters.currentOfficeId
            const data = event.data
            if (curOfficeId === 1) {
              if (!this.hqViewAllDetail) {
                return
              }
            } else {
              let needCheck = true
              if (!this.isZy && this.hierarchyViewDetail) {
                if (this.childOfficeIds.includes(data.opOffice) || this.childOfficeIds.includes(data.salesOffice)) {
                  needCheck = false
                }
              }
              if (needCheck) {
                if (data.opOffice !== curOfficeId && data.salesOffice !== curOfficeId && !this.mactchCooperateBranch(data.cooperatebranch, this.$store.getters.currentOffice)) {
                  return
                }
              }
            }
          }
          this.toLook(event.data)
        },
        getRowStyle: (params) => {
          if (!params.data) {
            return {}
          }
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row && row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      dargGroupShowColumnDef: {
        headerName: this.$t('SeaExport.BusinessNo'),
        colId: 'jobNo',
        field: 'jobNo',
        width: 240,
        wrapText: false,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            return false
          }
          return true
        },
        cellRenderer: params => {
          const currentJob = params.data
          if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
            const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
            return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
          }
          return params.value
        },
        excelRenderer: params => params.value
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: 'relatedJob',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data && params.data.customerId > 0) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.data.customerTypeId, 'chineseName')
            }
            return ''
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCargoSalesId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.departureStation'),
          colId: 'departureStation',
          field: 'departureStation',
          enableRowGroup: true,
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.transferStation'),
          colId: 'transferStation',
          field: 'transferStation',
          enableRowGroup: true,
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.transitStation'),
          colId: 'transitStation',
          field: 'transitStation',
          enableRowGroup: true,
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.data.transitStation, 'auto_railway') : ''
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.destinationStation'),
          colId: 'destinationStation',
          field: 'destinationStation',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.data.destinationStation, 'auto_railway') : ''
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'crossTenantHistoryState',
          field: 'crossTenantHistoryState',
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.crossTenantHisStateCommonFun(params.data, params.data.crossTenantHistoryState)
            }
            return ''
          },
          filter: false,
          enableRowGroup: true,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationStatusTime'),
          colId: 'crossTenantHistoryStateDate',
          field: 'crossTenantHistoryStateDate',
          enableRowGroup: true,
          hide: true,
          width: 120
        }, {
          headerName: this.$t('RailwayExport.ETD2'),
          colId: 'etd',
          field: 'etd',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.ETA2'),
          colId: 'eta',
          field: 'eta',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.SequenceNumber'),
          colId: 'jobNo5',
          field: 'jobNo5',
          hide: true,
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.vessel'),
          colId: 'vessel',
          field: 'vessel',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.voyageFlight'),
          colId: 'voyageFlight',
          field: 'voyageFlight',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.mbl'),
          colId: 'mbl',
          field: 'mbl',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          colId: 'customerRefNo',
          field: 'customerRefNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.portAgent'),
          colId: 'portAgent',
          field: 'portAgent',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.forwardingAgent'),
          colId: 'forwardingAgent',
          field: 'forwardingAgent',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          colId: 'designationAgent',
          field: 'designationAgent',
          enableRowGroup: true,
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_3') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNos',
          field: 'containerNos',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          colId: 'customsBroker',
          field: 'customsBroker',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          colId: 'carryingCmp',
          field: 'carryingCmp',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          colId: 'warehouseCmp',
          field: 'warehouseCmp',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.loadingPlaceCompany'),
          colId: 'loadingPlaceCompany',
          field: 'loadingPlaceCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.signBillPlaceCompany'),
          colId: 'signBillPlaceCompany',
          field: 'signBillPlaceCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.dischargePortCompany'),
          colId: 'dischargePortCompany',
          field: 'dischargePortCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('RailwayExport.destinationPortCompany'),
          colId: 'destinationPortCompany',
          field: 'destinationPortCompany',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          colId: 'quantityContract',
          field: 'quantityContract',
          hide: true,
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          colId: 'weightContract',
          field: 'weightContract',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          colId: 'cubageContract',
          field: 'cubageContract',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          colId: 'quantityActual',
          field: 'quantityActual',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          colId: 'weightActual',
          field: 'weightActual',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          colId: 'cubageActual',
          field: 'cubageActual',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          colId: 'chargeWeight',
          field: 'chargeWeight',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('RailwayExport.containerLoadType'),
          colId: 'containerLoadType',
          field: 'containerLoadType',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
            }
            return ''
          },
          filter: false,
          filterParams: {},
          width: 75
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          colId: 'cargoSource',
          field: 'cargoSource',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.TaxNature'),
          field: 'taxNature',
          colId: 'taxNature',
          cellRenderer: params => {
            return ColumnUtils.taxNatureLabelFunction(params.value)
          },
          width: 120
        },
        {
          headerName: this.$t('SeaExport.LocalService'),
          colId: 'loadingTerm',
          field: 'loadingTerm',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.loadingTermLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          colId: 'poNo',
          field: 'poNo',
          enableRowGroup: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerDescription'),
          colId: 'containerDesc',
          field: 'containerDesc',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerNo') + '-' + this.$t('SeaExport.SealNo'),
          colId: 'tmpContainerNo',
          field: 'tmpContainerNo',
          enableRowGroup: true,
          hide: true,
          valueGetter: params => {
            if (params.data) {
              const lines = params.data.tmpContainerNo.split(',')
              let label = ''
              for (const line of lines) {
                if (!line || line.startsWith('-') || line.endsWith('-')) {
                  continue
                }
                if (label) {
                  label += ','
                }
                label += line
              }
              return label
            } else {
              return ''
            }
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          colId: 'sopState',
          field: 'sopState',
          enableRowGroup: true,
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('SeaExport.TEU'),
          colId: 'teu',
          field: 'teu',
          hide: true,
          enableRowGroup: true,
          width: 150,
          summaryMode: 'sum'
        }, {
          headerName: this.$t('SeaExport.Operation'),
          colId: 'op',
          field: 'op',
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOpId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          colId: 'sales',
          field: 'sales',
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateSales), 'auto_sales')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        },
        { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp', enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateOverseaOp), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.FieldOperation'), field: 'siteOp', width: 180, colId: 'siteOp', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          colId: 'csr',
          field: 'csr',
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateCsrId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.overseaOp'),
          colId: 'overseaOp',
          field: 'overseaOp',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.planner'),
          colId: 'planner',
          field: 'planner',
          enableRowGroup: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperatePlanner), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCreator'),
          colId: 'createdBy',
          field: 'createdBy',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.data.createdBy, 'chineseName')
            }
            return ''
          },
          width: 75
        }, {
          headerName: this.$t('SeaExport.Accrued'),
          colId: 'provisioned',
          field: 'provisioned',
          enableRowGroup: true,
          hie: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          colId: 'shutOut',
          field: 'shutOut',
          enableRowGroup: true,
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOutDate'),
          field: 'shutOutDate',
          colId: 'shutOutDate',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Status'),
          colId: 'jobState',
          field: 'jobState',
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.getJobStateForBlock(params.data)
            }
            return ''
          },
          filter: false,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLConsignee'),
          colId: 'hBLConsignee',
          field: 'hBLConsignee',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLShipper'),
          colId: 'shipperCode',
          field: 'shipperCode',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          colId: 'cargoType',
          field: 'cargoType',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          colId: 'customJobType',
          field: 'customJobType',
          enableRowGroup: true,
          hide: true,
          valueGetter: params => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.customJobType.toString(), 'name', params.data.lob, this.isFba)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationTips'),
          colId: 'operationTips',
          field: 'operationTips',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          colId: 'remarks',
          field: 'remarks',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          colId: 'userDefinedField1',
          field: 'userDefinedField1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          colId: 'userDefinedField2',
          field: 'userDefinedField2',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          colId: 'userDefinedField3',
          field: 'userDefinedField3',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          colId: 'cargoChineseName',
          field: 'cargoChineseName',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          colId: 'cargoEnglishName',
          field: 'cargoEnglishName',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          colId: 'shipperLine1',
          field: 'shipperLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.NotifyParty'),
          colId: 'notifyLine1',
          field: 'notifyLine1',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          colId: 'customsDate',
          field: 'customsDate',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ManageAuditStatus'),
          colId: 'manageAuditStatus',
          field: 'manageAuditStatus',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.manageAuditStatusLabelFunction(params.value)
          },
          width: 110
        }, {
          headerName: this.$t('SeaExport.DoorAddress'),
          colId: 'doorAddr',
          field: 'doorAddr',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('RailwayExport.transportType'),
          colId: 'transportType',
          field: 'transportType',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.transportTypeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.ATD2'),
          colId: 'atd',
          field: 'atd',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('RailwayExport.ATA2'),
          colId: 'ata',
          field: 'ata',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Documents'),
          colId: 'dc',
          field: 'dc',
          enableRowGroup: true,
          hide: true,
          cellRenderer: params => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateDcId), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
          field: 'receivableChargeLockedStatus',
          colId: 'receivableChargeLockedStatus',
          hide: true,
          enableRowGroup: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
          field: 'payableChargeLockedStatus',
          colId: 'payableChargeLockedStatus',
          hide: true,
          enableRowGroup: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          enableRowGroup: true,
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId1), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          enableRowGroup: true,
          width: 150,
          valueFormatter: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.cooperateUserDefinedRoleId2), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRoleId3',
          colId: 'userDefinedRoleId3',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRoleId4',
          colId: 'userDefinedRoleId4',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRoleId5',
          colId: 'userDefinedRoleId5',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRoleId6',
          colId: 'userDefinedRoleId6',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRoleId7',
          colId: 'userDefinedRoleId7',
          enableRowGroup: true,
          hide: true,
          width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PreCommitUser'),
          field: 'preCommitUser',
          colId: 'preCommitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.PreCommitDate'),
          field: 'preCommitDate',
          colId: 'preCommitDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.CommitUser'),
          field: 'commitUser',
          colId: 'commitUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.SubmissionDate'),
          field: 'submissionDate',
          colId: 'submissionDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditUser'),
          field: 'fcAuditUser',
          colId: 'fcAuditUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.FcAuditDate'),
          field: 'fcAuditDate',
          colId: 'fcAuditDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobUser'),
          field: 'lockJobUser',
          colId: 'lockJobUser',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op')
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.LockJobDate'),
          field: 'lockJobDate',
          colId: 'lockJobDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'),
          field: 'salesOffice',
          colId: 'salesOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateSalesOffice), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          field: 'opOffice',
          colId: 'opOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateOpCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SalesDepartment'),
          field: 'salesDept',
          colId: 'salesDept',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateSalesDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
          field: 'opDepartment',
          colId: 'opDepartment',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.data.cooperateOpDepartment), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('RailwayExport.plannerDepartment'),
          field: 'plannerDepartment',
          colId: 'plannerDepartment',
          enableRowGroup: true,
          hide: true,
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.CustomerContactPerson'),
          field: 'customerContact',
          colId: 'customerContact',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SettlementType'),
          field: 'creditDateLimited',
          colId: 'creditDateLimited',
          hide: true,
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data) {
              return (Number(params.data.creditDateLimited) > 0 || Number(params.data.creditDateType) > 0) ? this.$t('Message.Monthly') : this.$t('Message.ByTicket')
            }
            return ''
          },
          filter: true,
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data.creditDateLimited !== '') {
              return (Number(params.data.creditDateLimited) > 0 || Number(params.data.creditDateType) > 0) ? this.$t('Message.Monthly') : this.$t('Message.ByTicket')
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvoicingMethod'),
          field: 'creditDateType',
          colId: 'creditDateType',
          hide: true,
          enableRowGroup: true,
          valueGetter: params => {
            if (params.data && params.data.creditDateType !== '') {
              return Number(params.data.creditDateType) > 0 ? this.$t('CargoMsg.Cargo_LotteryDraw') : this.$t('CargoMsg.Cargo_SchoolMonth')
            }
            return ''
          },
          filter: true,
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data.creditDateType !== '') {
              return Number(params.data.creditDateType) > 0 ? this.$t('CargoMsg.Cargo_LotteryDraw') : this.$t('CargoMsg.Cargo_SchoolMonth')
            }
            return ''
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactPhone'),
          field: 'telephone',
          colId: 'telephone',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContactMobile'),
          field: 'mobile',
          colId: 'mobile',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('queryJob.receivablesWriteOfStatus'),
          colId: 'verifyStateReceivable',
          field: 'verifyStateReceivable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('queryJob.payablesWriteOfStatus'),
          colId: 'verifyStatePayable',
          field: 'verifyStatePayable',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
          field: 'receivableChargeInput',
          colId: 'receivableChargeInput',
          width: 150,
          enableRowGroup: true,
          hide: true,
          filter: false,
          filterParams: {},
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.chargeInputLabelFunction(params.data.receivableChargeInput)
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
          field: 'costChargeInput',
          colId: 'costChargeInput',
          width: 150,
          hide: true,
          enableRowGroup: true,
          filter: false,
          filterParams: {},
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.chargeInputLabelFunction(params.data.costChargeInput)
            }
            return ''
          }
        }, {
          headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
          colId: 'receivableInvoiceState',
          field: 'receivableInvoiceState',
          width: 150,
          enableRowGroup: true,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.MasterBusinessNo'),
          colId: 'masterJobNo',
          field: 'masterJobNo',
          width: 150,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('RailwayExport.transportLine'),
          colId: 'transportLine',
          field: 'transportLine',
          width: 150,
          enableRowGroup: true,
          hide: true,
          valueGetter: params => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabelV2(TYPE_NAMES.basic_data_RailwayLine, 'code', params.data.transportLine, 'name')
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.jobBussStateLabelFunc(params.data.lob)
            }
            return ''
          },
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
          field: 'trackingTemplateUuid',
          width: 180,
          enableRowGroup: true,
          colId: 'trackingTemplateUuid',
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.data.trackingTemplateUuid, 'templateName')
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          enableRowGroup: true,
          width: 160, minWidth: 160,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          enableRowGroup: true,
          width: 200, minWidth: 200,
          hide: !this.useOrderCenterMode
        },
        { headerName: this.$t('CargoMsg.Cargo_JobProfitShare'), colId: 'jobProfitShare', field: 'jobProfitShare', width: 130, minWidth: 130,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('queryJob.EstimatedReviewer'),
          field: 'preverifier',
          colId: 'preVerifier',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('queryJob.DateOfPreReview'),
          field: 'preverifyDate',
          colId: 'preVerifyDate',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessExpirationDate'), field: 'specialApprovalDate', width: 150, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TransitTerm'),
          field: 'freightTerm',
          colId: 'freightTerm',
          enableRowGroup: true,
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          hide: true,
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          width: 180,
          hide: true,
          enableRowGroup: true,
          colId: 'incoTerm'
        }, {
          headerName: this.$t('SeaExport.Marks'),
          field: 'mark',
          colId: 'mark',
          enableRowGroup: true,
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerOffice'),
          field: 'csrOffice',
          colId: 'csrOffice',
          hide: true,
          enableRowGroup: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateCsrCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DocumentOffice'),
          field: 'dcOffice',
          colId: 'dcOffice',
          enableRowGroup: true,
          hide: true,
          width: 100,
          cellRenderer: (params) => {
            if (this.useOrderCenterMode && params.data && params.data.cooperateBranchId) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.data.cooperateDcCompany), 'chineseName')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.CustomsDeclarationType'), field: 'customsDeclarationType', width: 180, colId: 'customsDeclarationType', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.customClaim2LabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'userDefinedField4', width: 180, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.MethodOfPayment'), field: 'paymentMethod', width: 180, colId: 'paymentMethod', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.paymentMethodLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableDomestic'),
          colId: 'verifyStateReceivableDomestic',
          field: 'verifyStateReceivableDomestic',
          width: 140,
          enableRowGroup: true,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_VerifyStateReceivableOversea'),
          colId: 'verifyStateReceivableOversea',
          field: 'verifyStateReceivableOversea',
          width: 140,
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('Partners.PlateNumber'), field: 'truckingPlateNumber', colId: 'truckingPlateNumber', enableRowGroup: true, width: 200, hide: true },
        { headerName: this.$t('SeaExport.Driver'), field: 'driverName', colId: 'driverName', width: 200, enableRowGroup: true, hide: true },
        { headerName: this.$t('SeaExport.BusinessLockedStatus'), field: 'businessLock', width: 100, colId: 'businessLock',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLockedStatusLabelFunc(stringToBool(params.value))
          },
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_1') : ''
          },
          width: 200
        },
        {
          headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
          colId: 'payableInvoiceState',
          field: 'payableInvoiceState',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.receivableInvoiceStateLabelFunction(params.data.payableInvoiceState),
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReceivableFeeLockTime2'),
          colId: 'receivableChargeLockedDate',
          field: 'receivableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime2'),
          colId: 'payableChargeLockedDate',
          field: 'payableChargeLockedDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
          colId: 'payableChargeLockedPerson',
          field: 'payableChargeLockedPerson',
          width: 150,
          hide: true,
          enableRowGroup: true,
          valueGetter: (params) => {
            return ColumnUtils.getPayableChargeLockedPerson(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
          colId: 'interestAmountCurrency',
          field: 'interestAmountCurrency',
          width: 140,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CheckRuleResult'),
          colId: 'checkRuleResult',
          field: 'checkRuleResult',
          width: 100,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.CheckRuleResultLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ExportControlledProducts'),
          field: 'exportControlledProduct',
          colId: 'exportControlledProduct',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ExportControlledProduct, 'code', params.value, 'chineseName') : ''
          },
          width: 120
        }
      ],
      fbaColumns: [
        { headerName: 'Shipment ID', field: 'shipmentId', width: 180, colId: 'shipmentId', enableRowGroup: true },
        { headerName: this.$t('Warehouse.CommissionNo'), field: 'commissionNo', width: 180, colId: 'commissionNo', enableRowGroup: true },
        { headerName: this.$t('FbaJob.AmazonWarehouseCode'), field: 'warehouseCode', width: 180, colId: 'warehouseCode', enableRowGroup: true },
        { headerName: this.$t('Warehouse.ServiceChannel'), field: 'serviceChannel', width: 180, colId: 'serviceChannel', enableRowGroup: true },
        { headerName: 'Reference Id', field: 'referenceId', width: 180, colId: 'referenceId', enableRowGroup: true },
        {
          headerName: this.$t('Warehouse.PoOriginalOrderNo'),
          field: 'poNumber',
          width: 180,
          colId: 'poNumber',
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ValueAddedServices'),
          field: 'valueAddedServices',
          width: 180,
          enableRowGroup: true,
          colId: 'valueAddedServices'
        },
        {
          headerName: this.$t('Warehouse.RemoteWarehouse'),
          field: 'remoteWarehouse',
          width: 180,
          enableRowGroup: true,
          colId: 'remoteWarehouse',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('Warehouse.EstEnteringAmazonWarehouse'),
          field: 'preAmazonWhTime',
          width: 180,
          colId: 'preAmazonWhTime',
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ChargingMethod'), field: 'chargingMethod', width: 180, colId: 'chargingMethod', enableRowGroup: true,
          valueFormatter: (params) => {
            if (!params.value) return
            return Number(params.value) ? 'CBM' : 'KG'
          }
        },
        {
          headerName: this.$t('Warehouse.WeighTime'), field: 'weighTime', width: 180, colId: 'weighTime', enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ChecklistTime'), field: 'checklistTime', width: 180, colId: 'checklistTime', enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.ReturnGoodsTime'),
          field: 'returnGoodsTime',
          width: 180,
          enableRowGroup: true,
          colId: 'returnGoodsTime',
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Warehouse.ReturnReason'), field: 'returnReason', width: 180, colId: 'returnReason', enableRowGroup: true },
        {
          headerName: this.$t('Warehouse.ChecklistResult'),
          field: 'checklistStatus',
          width: 180,
          enableRowGroup: true,
          colId: 'checklistStatus',
          valueFormatter: (params) => {
            return ColumnUtils.checklistResultLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.$t('SpecialGoods.StuffingTime'), field: 'packingTime', width: 180, colId: 'packingTime', enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.OperationStatusOfForeignWarehouse'),
          field: 'outWarehouseStatus',
          width: 180,
          enableRowGroup: true,
          colId: 'outWarehouseStatus',
          valueFormatter: (params) => {
            return ColumnUtils.outWarehouseStatusLabelFunc(Number(params.value))
          }
        }
      ],
      arSettlementUnitOptional: false,
      rowData: [],
      gridApi: null,
      selectedRowIndex: -1,
      selectedRows: [],
      documentManage: new DocumentManage(),
      exportCommand: this.$t('SeaExport.ExportToExcel'),
      chargeCommand: this.$t('SeaExport.AddCharges'),
      stateDialog: {
        visible: false,
        rows: [],
        trackingList: []
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      statisticsDialog: {
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txt20: 0,
        txt40: 0,
        txt40hq: 0,
        txt45: 0,
        txtTeu: 0,
        txtWeight: 0.000,
        txtChargeWeight: 0.000,
        txtCubage: 0.000,
        txtdesignationAgentNum: 0,
        containShutOutJob: false
      },
      transshipDialog: {
        visible: false,
        jobKeys: [],
        selectedJobs: [],
        isDBFlag: true,
        txtVessel: '',
        txtVessel_1: '',
        txtVoyage: '',
        txtVoyage_1: '',
        dfETD: '',
        txtPortAgent: '',
        voyages: '',
        transship: {}
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new RailwayExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      addChargeDetailDialog: {
        visible: false,
        type: 0,
        selectedScheme: [],
        selectedJobs: []
      },
      chargeTypeDialog: {
        visible: false,
        selectedJobs: [],
        type: 0
      },
      role: {
        addReceivableChargeRole: this.$checkPermission(['button_Charge_payAddCharge']),
        addPayableChargeRole: this.$checkPermission(['button_Charge_costAddCharge'])
      },
      editChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      deleteChargeDetailDialog: {
        visible: false,
        selectedJobs: []
      },
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      exportOrderCommand: this.$t('SeaExport.Add'),
      importJobLobDialog: { // 导入业务类型选择弹窗
        visible: false,
        lob: 'RE'
      },
      podInfo: { // 批量修改目的港信息
        visible: false,
        keys: [],
        estimatedDeliveryToWarehouseTime: '',
        deliveryTime: '',
        destPortDeliveryTime: '',
        deliveryCompletionDate: '',
        estDeliveryTime: '',
        actDeliveryTime: '',
        estimatedReturnTime: '',
        destPortReturnTime: ''
      },
      customSearchItems: [],
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      JobUtils,
      paramsBpm: [],
      opOffice: null,
      batchModifyBusinessDialog: {
        visible: false,
        jobList: [],
        jobKeys: [],
        lob: ''
      },
      changeSopTemplateDialog: {
        visible: false,
        jobList: [],
        lob: ''
      },
      batchCooperationDialog: {
        visible: false,
        jobList: []
      },
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        needCheckRange: true,
        isSea: false,
        lob: 'RB',
        source: 'jobList',
        chargeType: null,
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      downloadImportTemplateDialog: {
        visible: false,
        lob: 'RB'
      },
      workFlowApplyDialog: {
        visible: false
      },
      isBpmEnabled: false,
      defaultSearchItems: [],
      gpExplain: {
        type: 'list',
        visible: false,
        jobUuids: []
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      isZY: false,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      clearCheckBox: {
        vessel: false,
        voyage: false,
        portAgent: false
      },
      reInstructioinBtns: [], // 出口-指令按钮列表
      riInstructioinBtns: [] // 进口-指令按钮列表
    }
  },
  computed: {
    searchItemConfigModule() {
      return this.isFba ? '10014' : '300'
    },
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    selectedRow() {
      if (this.gridApi) {
        let uuid
        this.gridApi.forEachNode(node => {
          if (node && node.data && this.selectedRowIndex === node.rowIndex) {
            uuid = node.data.uuid
          }
        })
        if (uuid) {
          let key
          this.rowData.map((item, index) => {
            if (item.uuid === uuid) {
              key = index
            }
          })
          return this.rowData[key]
        }
        return this.rowData[this.selectedRowIndex]
      } else {
        return this.rowData[this.selectedRowIndex]
      }
    },
    enableBtnSplit() {
      return this.selectedRows.findIndex(p => p.lclMasterUuid) >= 0
    },
    batchSelectFlag() {
      return this.selectedRows.length > 0
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    actionOrderUrl() {
      return URL.sys.importOrderTemplate
    },
    finalColumnDefs() {
      if (this.$store.state.uiCustom.enable && !this.isFba) {
        return UICustomUtil.handleColumnDefs(UICustomConstants.RAILWAY_BOOKING_MODULE, this.$store.getters.currentOfficeId, this.columnDefs)
      }
      return this.columnDefs
    },
    fbaColumnDefs() {
      return [...this.columnDefs, ...this.fbaColumns]
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return cache.config ? Number(cache.config.get('useOrderCenterMode')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return cache.config ? Number(cache.config.get('orderCenterBranch')) === 1 : false
    },
    location() {
      if (!this.isFba) {
        return LOG_RE_RAILWAY_BOOKING.code
      }
      return ''
    },
    isHQ() {
      return this.$store.getters.currentOfficeId === 1
    },
    conditonDisplayAllBranchData() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList
    },
    hqDisabledViewDetail() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllList && !this.hqViewAllDetail
    },
    validSingleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (!this.isZy && this.hierarchyViewDetail && this.selectedRow) {
          if (this.childOfficeIds.includes(this.selectedRow.opOffice) || this.childOfficeIds.includes(this.selectedRow.salesOffice)) {
            return true
          }
        }
        if (this.selectedRow && this.selectedRow.opOffice !== this.$store.getters.currentOfficeId && this.selectedRow.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.selectedRow.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      return true
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.selectedRows) {
          if (!this.isZy && this.hierarchyViewDetail && row) {
            if (this.childOfficeIds.includes(row.opOffice) || this.childOfficeIds.includes(row.salesOffice)) {
              return true
            }
          }
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        if (this.hierarchyViewList) {
          this.customSearchItems = await this.getCustomSearchItems()
        }
        this.loadInstructionButtons()
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.allowPartialCheckPass = Number(this.context.config.get('allowPartialCheckPass')) === 1
    this.ticketsMustBeVoted = Number(this.context.config.get('TicketsMustBeVoted')) === 1
    this.checkApChargeVerify = Number(this.context.config.get('PreCommitJobCheckApChargeStateVerify')) === 1
    this.useCheckRule = Number(this.context.config.get('useCheckRule')) === 1
    this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
    this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
    this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
      documentConfigId: Job_CHARGE.code,
      officeId: this.$store.getters.currentOfficeId
    })
    await this.initColumnDefs()
    this.customSearchItems = await this.getCustomSearchItems()
    this.loadInstructionButtons()
    if (this.isQuery) return
    this.queryLastModifyBookingByDay()
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showBusinessInfo', function() {
      self.showBusinessInfo()
    })
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(self, self.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: bookingTreeGridJS.methods
}
</script>

<style scoped lang="scss">
</style>
